import { combineReducers } from 'redux';
import { reducer as base } from './base';
import { reducer as configData } from './configData';
import { reducer as configContainer } from './configContainer';
import { reducer as logData } from './logData';

export default combineReducers({
  base,
  configData,
  configContainer,
  logData,
});
